import React from 'react'
import { ElementProps } from '../base/element'
import { Item } from '../base/item'
import { defStyleChildren } from '../helpers/utils'
import {
  IComponent,
  IContainerComponent,
  IDefaultStyles,
  IStyles
} from '../schemamanager/types'
import { IDataTableComponent } from './datatable'

export interface IModalComponent extends IContainerComponent {
  type: 'modal'
  name: string
  label?: string
  headerComponent?: IComponent
  styleDialog?: IStyles
  styleHeader?: IStyles
  styleLabel?: IStyles
  styleChildren?: IStyles
}

export const Modal = (props: ElementProps) => {
  const { sm, children } = props
  const comp = props.comp as IModalComponent

  const style: IDefaultStyles = {
    main: {
      classes: {
        justifyContent: 'justify-center',
        alignItems: 'items-center',
        display: 'flex',
        overflow: 'overflow-x-hidden overflow-y-auto',
        position: 'fixed',
        topRightBottomLeft: 'inset-0',
        zIndex: 'z-50',
        outline: 'outline-none',
        focus: {
          outline: 'focus:outline-none'
        }
      }
    },
    styleDialog: {
      classes: {
        borderWidth: 'border-4',
        borderColor: 'border-gray-300',
        padding: 'p-4',
        backgroundColor: 'bg-gray-100',
        backgroundOpacity: 'bg-opacity-30'
      }
    },
    styleHeader: {
      classes: {
        padding: 'px-6 py-4'
      }
    },
    styleLabel: {
      classes: {
        margin: 'mb-2',
        fontSize: 'text-xl',
        fontWeight: 'font-bold'
      }
    },
    ...defStyleChildren()
  }

  if (!comp.name) return <h4>No name for modal defined!</h4>

  const closeModal = (event: any) => {
    if (event.target === event.currentTarget) {
      if (comp.parentComp && comp.parentComp.type === 'datatable') {
        sm.RevertChangesDataTable(comp.parentComp as IDataTableComponent)
      }
      sm.CloseModal(comp.name)
    }
  }

  const m = props.mergeStyles(style)

  return (
    <div {...m.main} onClick={closeModal}>
      <div className='relative w-auto my-6 mx-auto max-w-sm'>
        <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none'>
          <div {...m.styleDialog}>
            <div {...m.styleHeader}>
              {comp.headerComponent && (
                <Item sm={sm} comp={comp.headerComponent} />
              )}
              {comp.label && <div {...m.styleLabel}>{comp.label}</div>}
            </div>
            <div {...m.styleChildren}>{children}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
